import React, { Component } from 'react'
import Field from 'components/controls/field'

class ProjectOption extends Component {
  constructor (props) {
    super(props)
    this.state = {
      checked: props.filterSelected? props.filteredItems.has(props.option.value) : !props.filteredItems.has(props.option.value),
    }
  }

  handleChange = (event) => {
    this.setState({ checked: !this.state.checked })
    this.props.onSelect(this.props.option, event)
  }

  render () {
    return (
      <Field
        className={this.props.className}
        type="checkbox"
        label={this.props.children}
        checked={this.state.checked}
        onChange={this.handleChange}
      />
    )
  }
}

export default ProjectOption
